// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { createEnumStyle } from "../EnumHelperFuncs";
export var UrlRedactionOptions = ( /* @__PURE__ */createEnumStyle({
    /**
     * The default value, will redact the username and password as well as the default set of query parameters
     */
    true: 1 /* eUrlRedactionOptions.true */,
    /**
     * Does not redact username and password or any query parameters, the URL will be left as is. Note: this is not recommended as it may lead
     * to sensitive data being sent in clear text.
     */
    false: 2 /* eUrlRedactionOptions.false */,
    /**
     * This will append any additional queryParams that the user has provided through redactQueryParams config to the default set i.e to
     * @defaultValue ["sig", "Signature", "AWSAccessKeyId", "X-Goog-Signature"].
     */
    appendToDefault: 3 /* eUrlRedactionOptions.appendToDefault */,
    /**
     * This will replace the default set of query parameters to redact with the query parameters defined in redactQueryParams config, if provided by the user.
     */
    replaceDefault: 4 /* eUrlRedactionOptions.replaceDefault */,
    /**
     * This will redact username and password in the URL but will not redact any query parameters, even those in the default set.
     */
    usernamePasswordOnly: 5 /* eUrlRedactionOptions.usernamePasswordOnly */,
    /**
     * This will only redact the query parameter in the default set of query parameters to redact. It will not redact username and password.
     */
    queryParamsOnly: 6 /* eUrlRedactionOptions.queryParamsOnly */
}));
//# sourceMappingURL=UrlRedactionOptions.js.map